<template>
  <div>
    <div class="container-nzidoo">
      <nav class="border-bottom bg-white" aria-label="Main categories">
        <div class="tabs-wrapper d-flex flex-nowrap px-2 px-sm-4" role="tablist" aria-orientation="horizontal"
          ref="tabsWrapper" @mousedown="startDrag" @mouseleave="stopDrag" @mouseup="stopDrag" @mousemove="onDrag"
          @touchstart="startDrag" @touchend="stopDrag" @touchmove="onDrag">
          <label v-for="tab in categoriesTab" :key="tab.id"
            class="tab-item cursor-pointer pb-1 pt-2 px-2 font-weight-bold transition text-nowrap border-bottom text-center text-muted border-transparent"
            role="tab" tabindex="0">
            <router-link v-if="tab.href" :to="tab.href" class="d-block text-decoration-none" @click.stop>
              {{ tab.label }}
            </router-link>
            <span v-else>{{ tab.label }}</span>
          </label>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabsNavigation",
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
    };
  },
  async beforeMount() {
    this.$store.dispatch("loadCategories");
  },
  computed: {
    categoriesTab() {
      return this.$store.getters.categories
    }
  }
  ,
  methods: {

    startDrag(e) {
      this.isDragging=true;
      this.startX=e.type.includes("touch")? e.touches[0].pageX:e.pageX;
      this.scrollLeft=this.$refs.tabsWrapper.scrollLeft;
      this.$refs.tabsWrapper.style.cursor="grabbing";
    },
    stopDrag() {
      this.isDragging=false;
      this.$refs.tabsWrapper.style.cursor="grab";
    },
    onDrag(e) {
      if (!this.isDragging) return;

      e.preventDefault();
      const x=e.type.includes("touch")? e.touches[0].pageX:e.pageX;
      const walk=(x-this.startX)*1.5; // Adjust scroll speed
      this.$refs.tabsWrapper.scrollLeft=this.scrollLeft-walk;
    },
  },
};
</script>

<style scoped>


.tabs-wrapper {
  display: flex;
  align-items: flex-end;
  height: 50px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  cursor: grab;
  user-select: none;
}

.tabs-wrapper::-webkit-scrollbar {
  display: none;
}

.tabs-wrapper.dragging {
  cursor: grabbing;
}

.tab-item {
  flex: 0 0 auto;
  white-space: nowrap;
  padding: 10px 16px;
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease;
  border-bottom: 2px solid transparent;
}

.tab-item:hover {
  color: var(--color-nz);
}

.tab-item.active {
  border-bottom: 2px solid var(--color-nz);
  color: var(--color-nz);
}

.container-nzidoo {
  overflow: hidden;
}

a.d-block {
  color: inherit;
  text-decoration: none;
  pointer-events: auto;
}

.transition {
  transition: color 0.2s ease, border-color 0.2s ease;
}


.border-transparent {
  border-color: transparent !important;
}

.border-bottom {
  border-bottom: 1px solid var(--gray-300);
}


@media (min-width: 576px) {

}

@media (max-width: 767px) {

}
</style>